import { render, staticRenderFns } from "./Chips.vue?vue&type=template&id=0722fa77&scoped=true&"
import script from "./Chips.vue?vue&type=script&lang=ts&"
export * from "./Chips.vue?vue&type=script&lang=ts&"
import style0 from "./Chips.vue?vue&type=style&index=0&id=0722fa77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0722fa77",
  null
  
)

export default component.exports